module.exports = __webpack_public_path__ + "media/images/close-5e2affeed380f56e8b81cdf403ead98d.svg";